// IssueTempPassword.jsx
import { useState } from 'react';
import InputMask from 'react-input-mask';
import { issueTempPassword } from '../utils/api'
import { Mail, Smartphone, Loader2, Copy, CheckCircle, AlertCircle } from 'lucide-react';

const IssueTempPassword = () => {
    const [email, setEmail] = useState('');
    const [mobile, setMobile] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [result, setResult] = useState(null);
    const [copied, setCopied] = useState(false);

    const handleSubmit = async () => {
        setError('');
        setResult(null);

        if (!email || !mobile) {
            setError('Both email and mobile are required');
            return;
        }

        const mobileDigits = mobile.replace(/\D/g, '');
        if (mobileDigits.length !== 10) {
            setError('Mobile must be 10 digits');
            return;
        }

                setLoading(true);
                 try {
                const data = await issueTempPassword({
                    email: email.toLowerCase().trim(),
                    mobile: mobile.replace(/\D/g, '')
                });
                setResult(data); 
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

    const handleCopy = () => {
        navigator.clipboard.writeText(result.temp_password);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    };

    const handleDone = () => {
        setResult(null);
        setEmail('');
        setMobile('');
        setError('');
    };

    return (
        <div className="min-h-screen bg-gradient-to-br from-gray-900 via-gray-800 to-black flex items-center justify-center px-4">
            <div className="max-w-lg w-full">
                <div className="bg-gray-900/50 rounded-3xl shadow-lg p-8" style={{ border: '1px solid #22d3ee' }}>
                    <h2 className="text-2xl font-bold text-white mb-6 text-center">
                        Issue Temporary Password
                    </h2>

                    {!result ? (
                        <div className="space-y-4">
                            <div>
                                <label className="block text-sm font-medium text-cyan-400 mb-1">
                                    User's email
                                </label>
                                <div className="relative">
                                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                        <Mail className="h-5 w-5 text-gray-400" />
                                    </div>
                                    <input
                                        type="email"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        placeholder="user@example.com"
                                        className="block w-full pl-10 pr-3 py-2 rounded-lg bg-gray-800/50 text-white border border-cyan-500 focus:outline-none"
                                    />
                                </div>
                            </div>

                            <div>
                                <label className="block text-sm font-medium text-cyan-400 mb-1">
                                    User's mobile
                                </label>
                                <div className="relative">
                                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                        <Smartphone className="h-5 w-5 text-gray-400" />
                                    </div>
                                    <InputMask
                                        mask="(999) 999-9999"
                                        type="tel"
                                        value={mobile}
                                        onChange={(e) => setMobile(e.target.value)}
                                        placeholder="(040) 274-2324"
                                        className="block w-full pl-10 pr-3 py-2 rounded-lg bg-gray-800/50 text-white border border-cyan-500 focus:outline-none"
                                    />
                                </div>
                            </div>

                            {error && (
                                <div className="flex items-center space-x-2 text-red-500 text-sm">
                                    <AlertCircle className="h-4 w-4" />
                                    <span>{error}</span>
                                </div>
                            )}

                            <button
                                onClick={handleSubmit}
                                disabled={loading}
                                className="w-full py-2 px-4 rounded-full bg-gradient-to-br from-gray-800 via-gray-700 to-black text-white font-medium disabled:opacity-50"
                                style={{ border: '1px solid #22d3ee' }}
                            >
                                {loading ? <Loader2 className="w-5 h-5 animate-spin mx-auto" /> : 'Generate Temp Password'}
                            </button>
                        </div>
                    ) : (
                        <div className="space-y-4">
                            <div className="bg-yellow-900/30 border-2 border-yellow-500 rounded-lg p-6 text-center">
                                <p className="text-yellow-300 text-sm mb-2">
                                    ⚠️ Shown once — write it down now
                                </p>
                                <div className="text-5xl font-mono font-bold tracking-widest text-white my-4">
                                    {result.temp_password}
                                </div>
                                <button
                                    onClick={handleCopy}
                                    className="text-cyan-400 text-sm flex items-center justify-center mx-auto hover:underline"
                                >
                                    {copied ? <><CheckCircle className="w-4 h-4 mr-1" /> Copied!</> : <><Copy className="w-4 h-4 mr-1" /> Copy</>}
                                </button>
                            </div>

                            <div className="text-gray-300 text-sm">
                                <p><strong>User:</strong> {result.user_name}</p>
                                <p className="text-yellow-300 text-xs mt-2">
                                    SMS the code to the user, then click below.
                                </p>
                            </div>

                            <button
                                onClick={handleDone}
                                className="w-full py-2 px-4 rounded-full bg-gradient-to-br from-gray-800 via-gray-700 to-black text-white font-medium"
                                style={{ border: '1px solid #22d3ee' }}
                            >
                                I've written it down and sent the SMS
                            </button>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default IssueTempPassword;